import { createAction, props } from '@ngrx/store';
import { CommonData } from '../interfaces/common-data';
import { ContractData } from '../dashboard/interfaces/contract-data';


export const AppActions = {
  setCommonData: createAction('Set common data', props<{commonData: CommonData}>()),
  setContractData: createAction('Set contract data', props<{contractData: ContractData | null}>()),
  setConditions: createAction('Set conditions', props<{conditions: string | null}>()),
  reset: createAction('Reset'),
  logout: createAction('Logout'),
};
